import React from 'react';
import {
  Drawer,
  DrawerProps,
  Button,
  Stack,
  CheckPicker
} from 'rsuite';
const data2 = [
  'Eugenia',
  'Bryan',
  'Linda',
  'Nancy',
  'Lloyd',
  'Alice',
  'Julia',
  'Albert',
  'Louisa',
  'Lester',
  'Lola',
  'Lydia',
  'Hal',
  'Hannah',
  'Harriet',
  'Hattie',
  'Hazel',
  'Hilda'
].map(item => ({ label: item, value: item }));

const DrawerView = (props: DrawerProps) => {
  const { onClose, ...rest } = props;
  return (
    <Drawer backdrop="static" size="xs" placement="right" onClose={onClose} {...rest}>
      <Drawer.Header>
        <Drawer.Title>Filters</Drawer.Title>
        <Drawer.Actions>
          <Button color="cyan" onClick={onClose} appearance="ghost">
            Cancel
          </Button>
          <Button color="cyan" onClick={onClose} appearance="primary">
            Confirm
          </Button>
        </Drawer.Actions>
      </Drawer.Header>
      <Drawer.Body>
          <Stack direction='column' alignItems='center'>
          <CheckPicker  data={data2} size="xs" appearance="default" placeholder="Category (5)" style={{ width: 350, marginBottom: 20, marginTop: 20 }} />
          <CheckPicker  data={data2} size="xs" appearance="default" placeholder="Sub-Category (6)" style={{ width: 350,  marginBottom: 20 }} />
          <CheckPicker  data={data2} size="xs" appearance="default" placeholder="Size (8)" style={{ width: 350, marginBottom: 20 }} />
          <CheckPicker  data={data2} size="xs" appearance="default" placeholder="Material (4)" style={{ width: 350, marginBottom: 20 }} />
          <CheckPicker  data={data2} size="xs" appearance="default" placeholder="Color (12)" style={{ width: 350, marginBottom: 20 }} />
          <CheckPicker placement="topStart" data={data2} size="xs" appearance="default" placeholder="Backgroud (5)" style={{ width: 350,  marginBottom: 20 }} />
          <CheckPicker placement="topStart" data={data2} size="xs" appearance="default" placeholder="Height (10)" style={{ width: 350,  marginBottom: 20 }} />
          <CheckPicker placement="topStart" data={data2} size="xs" appearance="default" placeholder="Width (12)" style={{ width: 350,  marginBottom: 20 }} />
          <CheckPicker placement="topStart" data={data2} size="xs" appearance="default" placeholder="Length (6)" style={{ width: 350,  marginBottom: 20 }} />
          <CheckPicker placement="topStart" data={data2} size="xs" appearance="default" placeholder="Image (14)" style={{ width: 350, marginBottom: 20 }} />
          <CheckPicker placement="topStart" data={data2} size="xs" appearance="default" placeholder="Light (10)" style={{ width: 350,  marginBottom: 20 }} />
          </Stack>
      </Drawer.Body>
    </Drawer>
  );
};

export default DrawerView;